import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';

class GetIndustryGroupSummaryBlockRequest extends BaseServiceRequest {
    constructor(symbol, endDate) {
        super();
        super.addRequestParameter("symbol", symbol);
        super.addRequestParameter("sdate", endDate);
        super.addRequestUri("indgroupsumblock.pb");
    }

    getMethod() {
        return HttpMethodType.GET;
    }

    getSubSystem() {
        return SubSystemType.GRAPH;
    }

    getMessageName() {
        return "SummaryBlockIndGroupDataResponse";
    }
}

export default GetIndustryGroupSummaryBlockRequest;